var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerSmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C5.5314 0 2.7 2.86 2.7 6.36364C2.7 8.55455 3.807 10.5018 5.4846 11.6482C2.2743 13.0391 0 16.2545 0 20H1.8C1.8 15.9727 5.013 12.7273 9 12.7273C12.987 12.7273 16.2 15.9727 16.2 20H18C18 16.2545 15.7257 13.0382 12.5154 11.6473C13.3718 11.0637 14.0735 10.2768 14.559 9.35567C15.0445 8.43452 15.2989 7.40718 15.3 6.36364C15.3 2.86 12.4686 0 9 0ZM9 1.81818C11.4957 1.81818 13.5 3.84273 13.5 6.36364C13.5 8.88455 11.4957 10.9091 9 10.9091C6.5043 10.9091 4.5 8.88455 4.5 6.36364C4.5 3.84273 6.5043 1.81818 9 1.81818Z",
    fill: "#5627FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSmIcon);
export default __webpack_public_path__ + "static/media/customer-sm-icon.f53693d4a59cbbfc62668c5936acf31c.svg";
export { ForwardRef as ReactComponent };